import LocalizedStrings from 'react-localization';

export let strings = new LocalizedStrings({
    en: {
        footer: {
            contactText: 'Contact',
            accountText: 'Account',
            legalText: 'Legal',
            loginText: 'Login',
            createAccText: 'Create account',
            paragraphText: 'Copyright © 2018 Frankie',
            privacyText: 'Privacy Policy',
            termsText: 'Terms of use',
            socials: 'Follow us on:',
            newsletterButton: 'Subscribe'
        }
    },
    es: {
        footer: {
            contactText: 'Contacto',
            accountText: 'Cuenta',
            legalText: 'Legalidad',
            loginText: 'Ingresar',
            createAccText: 'Crear cuenta',
            paragraphText: 'Copyright © 2018 Frankie',
            privacyText: 'Política de privacidad',
            termsText: 'Términos de uso',
            socials: 'Siguenos en:',
            newsletterButton: 'Subscribir'
        }
    }
});


// WEBPACK FOOTER //
// ./src/redux/components/organisms/Footer/FooterContent.js